import React from 'react';
import { Link } from 'react-router-dom';
import { X, Trash2, Plus, Minus, ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Button } from './ui/button';

const CartDrawer = () => {
  const { cart, isOpen, setIsOpen, removeFromCart, updateQty, total } = useCart();

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black/50 z-[60]" onClick={() => setIsOpen(false)}/>
      )}
      <aside className={`fixed top-0 right-0 h-full w-full max-w-md bg-white z-[70] shadow-2xl transform transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-5 border-b border-neutral-200">
            <h2 className="font-serif text-xl text-[#1a1a1a] flex items-center gap-2"><ShoppingBag size={20}/> Shopping Basket</h2>
            <button onClick={() => setIsOpen(false)} className="text-neutral-500 hover:text-[#1a1a1a]"><X size={22}/></button>
          </div>
          <div className="flex-1 overflow-y-auto p-5">
            {cart.length === 0 ? (
              <div className="h-full flex flex-col items-center justify-center text-center gap-3 text-neutral-500">
                <ShoppingBag size={48} className="text-neutral-300"/>
                <p>Your basket is currently empty.</p>
                <Button onClick={() => setIsOpen(false)} className="bg-[#b8892d] hover:bg-[#a07826] mt-2">Continue Shopping</Button>
              </div>
            ) : (
              <div className="space-y-4">
                {cart.map(item => (
                  <div key={item.id} className="flex gap-3 pb-4 border-b border-neutral-100">
                    <img src={item.image} alt={item.title} className="w-20 h-20 object-cover bg-neutral-50"/>
                    <div className="flex-1">
                      <h4 className="text-sm font-medium text-neutral-800 line-clamp-2">{item.title}</h4>
                      <div className="text-[#b8892d] font-semibold text-sm mt-1">₹{item.sale.toLocaleString('en-IN')}</div>
                      <div className="flex items-center gap-3 mt-2">
                        <div className="flex items-center border border-neutral-300">
                          <button onClick={() => updateQty(item.id, item.qty - 1)} className="w-7 h-7 flex items-center justify-center hover:bg-neutral-100"><Minus size={12}/></button>
                          <span className="w-8 text-center text-sm">{item.qty}</span>
                          <button onClick={() => updateQty(item.id, item.qty + 1)} className="w-7 h-7 flex items-center justify-center hover:bg-neutral-100"><Plus size={12}/></button>
                        </div>
                        <button onClick={() => removeFromCart(item.id)} className="text-neutral-400 hover:text-red-600 ml-auto"><Trash2 size={16}/></button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          {cart.length > 0 && (
            <div className="border-t border-neutral-200 p-5 space-y-3 bg-neutral-50">
              <div className="flex justify-between items-baseline">
                <span className="text-neutral-600">Subtotal</span>
                <span className="text-xl font-semibold text-[#1a1a1a]">₹{total.toLocaleString('en-IN')}</span>
              </div>
              <Link to="/checkout" onClick={() => setIsOpen(false)}>
                <Button className="w-full bg-[#b8892d] hover:bg-[#a07826] h-11 text-white uppercase tracking-widest text-sm">Checkout</Button>
              </Link>
              <Link to="/cart" onClick={() => setIsOpen(false)}>
                <Button variant="outline" className="w-full h-11 uppercase tracking-widest text-sm border-neutral-800 mt-2">View Basket</Button>
              </Link>
            </div>
          )}
        </div>
      </aside>
    </>
  );
};

export default CartDrawer;
